import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PrivacyPolicyEnhancer from "./Enhancer/PrivacyPolicyEnhancer";
import navigationAction from "redux/navigation/actions";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "reactstrap";
import {
  addPrivacyPolicy,
  getPrivacyPolicy
} from "services/privacyPolicyServices";
import Loader from "components/Loader";

const { success, error } = navigationAction;
function PrivacyPolicy(props) {
  const { sidebarTheme } = props;
  const {
    values,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    isValid
  } = props;

  let fetchPrivacyPolicy = option => {
    setLoading(true);
    getPrivacyPolicy({ Privacy_Policy_for: option }).then(res => {
      if (res.success) {
        setFieldValue("Privacy_Policy_for", option);
        setFieldValue(
          "Privacy_Policy_description",
          res.data?.Privacy_Policy_description
        );
        setLoading(false);
      } else {
        error(res.message);
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    fetchPrivacyPolicy("User");
  }, []);

  const options = [
    { value: "User", label: "User" },
    { value: "Merchant", label: "Merchant" }
  ];
  async function handleSubmitAction(e) {
    e.preventDefault();
    if (isValid) {
      setLoading(true);
      addPrivacyPolicy(token, values).then(res => {
        if (res.success) {
          success(res.message);
          getPrivacyPolicy({ Privacy_Policy_for: values.Privacy_Policy_for });
          setLoading(false);
        } else {
          error(res.message);
          setLoading(false);
        }
      });
    }
  }

  const activeColor = {
    color: sidebarTheme.activeColor
  };

  const [loading, setLoading] = useState(false);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.className ? props.className : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <>
      <div className="row">
        <div className="col mb-2">
          <div className="introduction" style={activeColor}>
            Privacy Policy
          </div>
        </div>
      </div>
      <div className="quill-tnc">
        <form>
          <div className="form-group my-3 col-4">
            <Select
              options={options}
              name="Privacy_Policy_for"
              placeholder="Select..."
              onBlur={handleBlur}
              onChange={e => {
                fetchPrivacyPolicy(e.value);
              }}
              value={
                values.Privacy_Policy_for
                  ? options.find(x => {
                      return x.value === values?.Privacy_Policy_for;
                    })
                  : "User"
              }
            />
            <Error field="Privacy_Policy_for" />
          </div>
          <div className="form-group w-100 col-12">
            <ReactQuill
              name="Privacy_Policy_description"
              theme="snow"
              value={values.Privacy_Policy_description}
              placeholder="Enter the description here..."
              onChange={(content, delta, source, editor) => {
                if (editor.getLength() <= 1) {
                  setFieldValue("Privacy_Policy_description", "");
                } else {
                  setFieldValue("Privacy_Policy_description", content);
                }
              }}
              onBlur={(previousRange, source, editor) => {
                setFieldValue("Privacy_Policy_description", editor.getHTML());
              }}
              modules={PrivacyPolicy.modules}
              formats={PrivacyPolicy.formats}
            />
            <Error field="Privacy_Policy_description" />
          </div>
          <div className="row justify-content-center">
            <div className="col-auto">
              <Button
                type="submit"
                className="btn btn-info w-100 btn-bordered"
                onClick={e => handleSubmitAction(e)}
              >
                Save
              </Button>
            </div>
          </div>
        </form>
      </div>
      {loading && <Loader />}
      {}
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default compose(
  PrivacyPolicyEnhancer,
  connect(mapStateToProps, { success, error })
)(PrivacyPolicy);
